import {
  Dialog as BaseDialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";
import React from "react";
import { useSearchParams } from "react-router";
type Props = {
  open: boolean;
  setOpen: (e: boolean) => void;
  title?: string;
  [key: string]: any;
};

const Dialog: React.FC<Props> = ({
  open,
  setOpen,
  title,
  description = "",
  children,
  ...props
}) => {
  const [searchParams] = useSearchParams();
  return (
    <>
      <BaseDialog open={open} onOpenChange={setOpen}>
        <DialogContent
          {...props}
          className={cn(["px-0", props.className])}
          onInteractOutside={(e) => {
            e.preventDefault();
          }}
        >
          {title && (
            <DialogHeader>
              <DialogTitle
                className={cn([
                  "px-[32px] pb-[20px]",
                  searchParams.get("confirm") ? "" : "border-b  capitalize",
                ])}
              >
                {title}{" "}
                {description && (
                  <div className="mt-[12px] text-[14px] font-[400] text-[#969696]">
                    {description}
                  </div>
                )}
              </DialogTitle>

              {/* <DialogDescription>
        
      </DialogDescription> */}
            </DialogHeader>
          )}
          <div className="px-[20px]">{children}</div>
        </DialogContent>
      </BaseDialog>
    </>
  );
};

export default Dialog;
